/**
 * * Scroll to the relative co-ordinate after collapse instead of absolute
 *
 * For example:-
 * If element w/o collapse is at Y1 co-ordinate, and then the drag starts,
 * now the element would still be at maximum of (Y1, parentHeight)
 *
 * But we need to move the element to Y2 co-ordinate where it is supposed to be
 * after/before it's sibling element
 *
 * @param nodeKey current dragging element node key
 * @param editor editor instance for current section/component
 *
 */
export default (params) => {
  setTimeout(() => {
    const { nodeKey } = params;
    const cardDOM = document.querySelector(`[data-key= '${nodeKey}']`);
    cardDOM.scrollIntoView();
  }, 0);
};
